export default "__VITE_ASSET__Ctphicwu__"